import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
const data = [{
  subject: 'OSINT',
  A: 90,
  fullMark: 100
}, {
  subject: 'AppSec',
  A: 85,
  fullMark: 100
}, {
  subject: 'NetSec',
  A: 75,
  fullMark: 100
}, {
  subject: 'Compliance',
  A: 80,
  fullMark: 100
}, {
  subject: 'Threat Intel',
  A: 85,
  fullMark: 100
}, {
  subject: 'Incident Resp',
  A: 70,
  fullMark: 100
}, {
  subject: 'Product Mgmt',
  A: 90,
  fullMark: 100
}, {
  subject: 'Technical',
  A: 85,
  fullMark: 100
}];
export function ExpertiseRadar() {
  return <div className="w-full h-[400px] flex flex-col items-center justify-center" data-id="element-53">
      <h3 className="text-xl font-semibold mb-4 text-center" data-id="element-54">
        Security Expertise Domain
      </h3>
      <ResponsiveContainer width="100%" height="100%" data-id="element-55">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data} data-id="element-56">
          <PolarGrid stroke="hsl(var(--muted-foreground))" strokeOpacity={0.2} data-id="element-57" />
          <PolarAngleAxis dataKey="subject" tick={{
          fill: 'hsl(var(--foreground))',
          fontSize: 12
        }} data-id="element-58" />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} data-id="element-59" />
          <Radar name="Expertise Level" dataKey="A" stroke="hsl(var(--primary))" strokeWidth={2} fill="hsl(var(--primary))" fillOpacity={0.3} data-id="element-60" />
          <Tooltip contentStyle={{
          backgroundColor: 'hsl(var(--popover))',
          borderColor: 'hsl(var(--border))',
          color: 'hsl(var(--popover-foreground))',
          borderRadius: 'var(--radius)'
        }} data-id="element-61" />
        </RadarChart>
      </ResponsiveContainer>
    </div>;
}